import { ActionTypes as action } from "./action-types";
import directoryService from "../../../api/directoryService";

const actions = {
    async createDirectory({ }, data) {
        await directoryService.createDirectory(data);
    },
    async updateDirectory({ }, data) {
        await directoryService.updateDirectory(data);
    },
    async getDirectoryList({ commit }) {
        const data = await directoryService.getDirectoryList();
        commit(action.GET_DIRECTORY_LIST, data);
    },
    async getDirectory({ }, id) {
        const data = await directoryService.getDirectory(id);
        return data;
    },

    async deleteDirectory({ }, id) {
        await directoryService.deleteDirectory(id);
    },
    async deleteDirectories({ }, data) {
        await directoryService.deleteDirectories(data);
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
};

export default actions;
